import styled from 'styled-components'


export const HomeContainer = styled.section`
    display: flex;
    height: 100%;
    justify-content: space-between;

    @media (max-width: 1000px) {
        flex-direction: column;
    }
`

